import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { navItems } from "../constant2";
import { Link, useNavigate } from "react-router-dom";

const NavBar = () => {
  const navigate = useNavigate();
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const toggleNavbar = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const handleScroll = (id) => {
    setMobileDrawerOpen(false); // Close menu after clicking
    navigate("/");
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <nav className="bg-gradient-to-b from-gray-100 to-gray-200 sticky top-0 z-50 py-3 backdrop-blur-lg border-b border-neutral-700/80 ">
      <div className="flex justify-between items-center px-4 lg:px-10 ">
        {/* Logo (Optional, Uncomment if needed) */}
        {/* <img src={logo} alt="Logo" className="h-10 w-10" /> */}

        {/* Desktop Navigation */}
        <ul className="hidden lg:flex space-x-8 items-center ">
          {navItems.map((item, index) => (
            <li
              key={index}
              className="hover:bg-purple-800 hover:border-purple-800 hover:rounded p-2 duration-300 relative overflow-hidden"
            >
              {item.path ? (
                <Link to={item.path} className="text-black">
                  {item.label}
                </Link>
              ) : (
                <button
                  onClick={() => handleScroll(item.id)}
                  className="text-black border-none cursor-pointer"
                >
                  {item.label}
                </button>
              )}
            </li>
          ))}
        </ul>

        {/* Mobile Menu Toggle Button */}
        <div className="lg:hidden ">
          <button onClick={toggleNavbar} aria-label="Toggle Navigation">
            {mobileDrawerOpen ? <X size={24} className="text-black transparent " /> : <Menu size={24} className="text-white" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileDrawerOpen && (
        <div className="fixed inset-0 z-20 bg-neutral-900 p-8 flex flex-col items-center lg:hidden ">
          {/* Close Menu Button */}
          <button
            onClick={toggleNavbar}
            className="absolute top-4 right-4 text-white"
            aria-label="Close Navigation"
          >
            <X size={24} />
          </button>

          {/* Navigation Links */}
          <ul className="space-y-6 backdrop-blur-md">
            {navItems.map((item, index) => (
              <li key={index} className="text-center">
                {item.path ? (
                  <Link
                    to={item.path}
                    onClick={toggleNavbar} // Close menu after navigation
                    className="text-white hover:bg-purple-800 px-4 py-2 rounded"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <button
                    onClick={() => handleScroll(item.id)}
                    className="text-white hover:bg-purple-800 px-4 py-2 rounded"
                  >
                    {item.label}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
